import React, { useState, useEffect, useMemo } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardImg,
  Col,
  Row,
  Spinner,
} from "reactstrap";
import image1 from "../../../../assets/orderingSystem/burger.jpeg";
import { Link } from "react-router-dom";
import CustomerForm from "./component/CustomerForm";
import CustomerList from "./component/CustomerList";
import toast from "react-hot-toast";
import OrderServices from "../../../../services/OrderingServices/OrderServices";
import restro from "../../../../assets/orderingSystem/restrologo.png";
import ConfirmPayment from "./component/ConfirmPayment";
import PrintBillModal from "./component/PrintBillModal";
import PaymentMethod from "./component/PaymentMethod";
import InvoiceBillModal from "./component/InvoiceBillModal";
import KOTModal from "./component/KOTModal";
import CancelOrder from "./component/CancelOrder";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrderItems,
  deleteUnplacedOrderItems,
  resetOrder,
} from "../../../../slices/Order/orderSlice";
import { getLoggedInUser } from "../../../../helpers/fakebackend_helper";
import FoodCourt from "../Table/page/FoodCourt";
import TableSwitch from "../Table/page/TableSwitch";

// Placeholder image (replace with actual import if available)

const OrderSummary = ({
  orderData,
  setIsQuantityChanged,
  isQuantityChanged,
  data,
  fetchTable,
  sectionData,
  setSelectedSection,
  selectedSection,
  fetchOrder,
  handlePlaceOrder,
  setSelectedTable,
  selectedTable,
  itemCounts,
  setItemCounts,
  placedLoading,
  placedItems,
  fetchKot,
  selectedCourt,
  setSelectedCourt,
}) => {
  
  // const orderData = [];
  const tableKey = String(selectedTable?.restrotableId);
  const orderNo = orderData?.[tableKey]?.items?.[0]?.orderNo ?? null;
  const orderId = orderData?.[tableKey]?.orderId ?? null;


  const [selectedCustomer, setSelectedCustomer] = useState(
    JSON.parse(localStorage.getItem("selectedCustomer")) || null
  );
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const orgInfo = user?.organizationInfo || {};
  const [isListOpen, setIsListOpen] = useState(false);
  const [isTableOpen, setIsTableOpen] = useState(true);
  const [isSwitchOpen, setIsSwitchOpen] = useState(false);
  const [isSwitchItemOpen, setIsSwitchItemOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const [promoSuccess, setPromoSuccess] = useState("");
  const [error, setError] = useState(null);
  const [isRight, setIsRight] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState([]);

  const [isPaymentModal, setIsPaymentModal] = useState(false);
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [lastUpdated, setLastUpdated] = useState(null);
  const [isKOTOpen, setIsKOTOpen] = useState(false);
  const [responseData, setResponseData] = useState();
  const [creditData, setCreditData] = useState();
  const [paymentAmounts, setPaymentAmounts] = useState({});

  const toggleKOT = () => setIsKOTOpen(!isKOTOpen);

  const togglePayment = () => setIsPaymentModal(!isPaymentModal);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const toggleListModal = () => setIsListOpen(!isListOpen);
  const toggleTableModal = () => setIsTableOpen(!isTableOpen);
  const toggleSwitchModal = () => setIsSwitchOpen(!isSwitchOpen);
  const toggleSwitchItemModal = () => setIsSwitchItemOpen(!isSwitchItemOpen);

  const toggleRightCanvas = () => setIsRight(!isRight);
  const dispatch = useDispatch();
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.user?.roles[0]?.toLowerCase();

  const handleApplyPromo = () => {
    if (!promoCode.trim()) {
      setPromoSuccess("");
      setPromoError("Please enter a promo code.");
      toast.error("Please enter a promo code.");
      return;
    }
    if (promoCode.toLowerCase() === "save10") {
      if (promoSuccess) {
        setPromoError("Promo code already applied.");
        toast.error("Promo code already applied.");
        return;
      }
      setPromoError("");
      setPromoSuccess("Promo applied! 10% discount.");
      toast.success("Promo applied! 10% discount.");
      setPromoCode("");
      setDiscountPercent("10");
      setLastUpdated(null);
      setDiscountAmount((calculateTotals.subTotal * 0.1).toFixed(2));
    } else {
      setPromoSuccess("");
      setPromoError("Invalid promo code.");
      toast.error("Invalid promo code.");
    }
  };

  const handleCheckboxChange = (itemKey, item) => {
    setSelectedItems((prev) => {
      // Check if the item is already selected
      const exists = prev.find((i) => i.itemKey === itemKey);
      if (exists) {
        // Remove it (unselect)
        return prev.filter((i) => i.itemKey !== itemKey);
      } else {
        // Add it
        return [...prev, { itemKey, ...item }];
      }
    });
  };

  const [remarks, setRemarks] = useState();
  const [touched, setTouched] = useState();
  const isInvalid = touched && !remarks?.trim();

  const handleDeleteItem = async () => {
    if (selectedItems.length === 0) {
      toast.error("No items selected for deletion.");
      return;
    }

    if (!remarks?.trim()) {
      setTouched(true);
      return;
    }

    try {
      const tableId = selectedTable?.id;
      const order = orderData[tableId];
      console.log("🚀 ~ handleDeleteItem ~ order:", order);

      const itemIndexes = selectedItems.map((key) => {
        const [orderIndex, itemIndex] = key.split("-").map(Number);
        return { orderIndex, itemIndex };
      });

      // Separate local and placed items
      const localItems = [];
      const placedItems = [];

      itemIndexes.forEach(({ orderIndex, itemIndex }) => {
        const item = orderData[orderIndex].items[itemIndex];
        if (item.isLocalItem) {
          localItems.push({ orderIndex, itemIndex });
        } else {
          placedItems.push(item.id); // API needs only the IDs
        }
      });

      // Delete local items
      if (localItems.length > 0) {
        dispatch(deleteOrderItems({ tableId, itemIndexes: localItems }));
      }

      // Delete placed items via API
      if (placedItems.length > 0) {
        await OrderServices.mulipleOrderCancel(tableId, placedItems, remarks);
        dispatch(deleteOrderItems({ tableId, itemIndexes }));
      }

      fetchOrder();
      setSelectedItems([]);
      setRemarks("");
      setTouched(false);
      toast.success("Selected items removed from order.");
      toggleDeleteModal();
    } catch (error) {
      console.error("Error deleting items:", error);
      toast.error("Failed to remove items.");
    }
  };

  const filteredOrders = useMemo(() => {
    const ordersArray = Object.values(orderData);
    console.log("🚀 ~ OrderSummary ~ ordersArray:", ordersArray);
    return selectedTable
      ? ordersArray.filter(
          (order) => order.tableId === selectedTable.restrotableId
        )
      : ordersArray;
  }, [orderData, selectedTable]);
  console.log("🚀 ~ OrderSummary ~ filteredOrders:", filteredOrders);

  const calculateTotals = useMemo(() => {
    let subTotal = 0;

    // Ensure filteredOrders is array
    const orders = Array.isArray(filteredOrders)
      ? filteredOrders
      : Object.values(filteredOrders);

    orders.forEach((order) => {
      // Each order has an `items` array
      const items = order.items || [];

      items.forEach((item, idx) => {
        // Generate a unique ID for item count override (optional)
        const tableIdentifier =
          order.restrotableId ??
          order.restrotableTitle ??
          order.tableId ??
          "unknown";
        const itemKey = `${tableIdentifier}-${item.productId}-${idx}`;

        // Use finalQuantity or fallback
        const count =
          itemCounts[itemKey] ?? item.finalQuantity ?? item.quantity ?? 0;

        // Determine price
        let itemPrice = 0;

        if (item.productPrice != null) {
          itemPrice = Number(item.productPrice);
        } else if (item.Rate != null) {
          itemPrice = Number(item.Rate);
        } else if (item.SRate != null) {
          itemPrice = Number(item.SRate);
        } else if (item.Amount != null) {
          itemPrice = Number(item.Amount) / (item.quantity || 1);
        } else if (
          Array.isArray(item.attributes) &&
          item.attributes.length > 0
        ) {
          itemPrice = item.attributes.reduce(
            (sum, attr) => sum + (parseFloat(attr.value) || 0),
            0
          );
        }

        // Add to subtotal
        subTotal += itemPrice * count;
      });
    });

    // --- Discount Logic (unchanged) ---
    let discount = 0;
    let effectiveDiscountPercent = 0;

    if (promoSuccess) {
      discount = subTotal * 0.1;
      effectiveDiscountPercent = 10;
    } else if (lastUpdated === "amount" && discountAmount) {
      discount = parseFloat(discountAmount) || 0;
      effectiveDiscountPercent = subTotal ? (discount / subTotal) * 100 : 0;
    } else if (lastUpdated === "percent" && discountPercent) {
      effectiveDiscountPercent = parseFloat(discountPercent) || 0;
      discount = (effectiveDiscountPercent / 100) * subTotal;
    } else if (
      selectedCustomer?.customerTypeDiscount &&
      !lastUpdated &&
      !promoSuccess
    ) {
      effectiveDiscountPercent =
        parseFloat(selectedCustomer.customerTypeDiscount) || 0;
      discount = (effectiveDiscountPercent / 100) * subTotal;
    }

    discount = Math.min(discount, subTotal);
    const total = Math.max(0, subTotal - discount);

    console.log("Totals:", {
      subTotal,
      discount,
      total,
      effectiveDiscountPercent,
    });

    return {
      subTotal,
      discount,
      total,
      effectiveDiscountPercent,
    };
  }, [
    filteredOrders, // Fixed: was orderData
    itemCounts,
    promoSuccess,
    discountPercent,
    discountAmount,
    lastUpdated,
    selectedCustomer,
  ]);
  console.log("🚀 ~ OrderSummary ~ calculateTotals:", calculateTotals);

  useEffect(() => {
    if (promoSuccess || lastUpdated) return;
    if (selectedCustomer?.customerTypeDiscount !== undefined) {
      const percent = parseFloat(selectedCustomer.customerTypeDiscount) || 0;
      const amount = (percent / 100) * (calculateTotals.subTotal ?? 0);
      setDiscountPercent(percent.toFixed(2));
      setDiscountAmount(amount.toFixed(2));
    } else {
      setDiscountPercent();
      setDiscountAmount();
    }
  }, [selectedCustomer, calculateTotals.subTotal, promoSuccess, lastUpdated]);

  useEffect(() => {
    if (discountAmount && !promoSuccess && lastUpdated === "amount") {
      const amount = parseFloat(discountAmount);
      if (
        !isNaN(amount) &&
        amount >= 0 &&
        amount <= (calculateTotals.subTotal ?? 0)
      ) {
        const percent = (amount / (calculateTotals.subTotal ?? 0)) * 100;
        const newPercent = percent.toFixed(2);
        if (newPercent !== discountPercent) {
          setDiscountPercent(newPercent);
        }
      }
    }
  }, [discountAmount, calculateTotals.subTotal, promoSuccess, lastUpdated]);

  const handlePercentChange = (e) => {
    const value = e.target.value;
    setDiscountPercent(value);
    setLastUpdated("percent");
    setPromoSuccess("");
    setPromoError("");

    const percent = parseFloat(value);
    if (!isNaN(percent) && calculateTotals.subTotal) {
      const amount = ((percent / 100) * calculateTotals.subTotal).toFixed(2);
      setDiscountAmount(amount);
    } else {
      setDiscountAmount();
    }

    if (!value) {
      setDiscountAmount("");
      setLastUpdated(null);
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setDiscountAmount(value);
    setLastUpdated("amount");
    setPromoSuccess("");
    setPromoError("");
    if (!value) {
      setDiscountPercent("");
      setLastUpdated(null);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const [billInfo, setBillInfo] = useState();
  const [totalCalculate, setTotalCalculate] = useState();

  const handleCheckout = async () => {
    if (!selectedTable?.id) {
      toast.error("Please select a table before checking out.");
      return;
    }
    if (!orderData || Object.keys(orderData).length === 0) {
      toast.error("No items in the order to checkout.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const creditPayment = selectedPayments.find((p) =>
        p.name.toLowerCase().includes("credit")
      );

      const creditLogs =
        creditPayment && creditData?.customerId && creditData?.amount
          ? {
              customerId: creditData.customerId,
              amount: creditData.amount,
              remarks: creditData.remarks,
            }
          : null;

      // Filter out Credit from multiplePayments
      const otherPayments = selectedPayments.filter(
        (p) => !p.name.toLowerCase().includes("credit")
      );

      const payload = {
        orderId: orderId,
        // If Credit exists, use its id; else use first other payment or 0
        paymentTypeId: creditPayment
          ? creditPayment.id
          : otherPayments[0]?.id || 0,
        multiplePayments: otherPayments.map((p) => ({
          paymentTypeId: p.id,
          amount: Number(paymentAmounts[p.id]) || 0,
        })),
        ...(creditLogs ? { creditLogs } : {}),
      };

      if (discountAmount && parseFloat(discountAmount) !== 0) {
        payload.discountAmount = discountAmount;
      }

      if (discountPercent && parseFloat(discountPercent) !== 0) {
        payload.discountPercentage = discountPercent;
      }

      const response = await OrderServices.checkout(payload);
      console.log("🚀 ~ handleCheckout ~ response:", response);

      toast.success("Checkout successful!");
      setResponseData(response);
      setBillInfo(orderData);
      dispatch(resetOrder());
      setTotalCalculate(calculateTotals);
      setIsModalOpen(true);
      setIsRight(false);
      fetchTable();
      fetchKot();
      setItemCounts({});
      setPromoCode("");
      setPromoError("");
      setPromoSuccess("");
      setDiscountPercent("");
      setDiscountAmount("");
      setCreditData({});
      setSelectedPayment(null);
      setSelectedTable(null);
      localStorage.removeItem("selectedTable");
      localStorage.removeItem("selectedCustomer");
    } catch (error) {
      console.error("Checkout error:", error);
      toast.error("Failed to complete checkout. Please try again.");
      setError("Failed to complete checkout.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTable?.id) {
      setIsTableOpen(false);
    }
  }, []);

  const handlePrint = async () => {
    try {
      const response = await OrderServices.kotprint(selectedTable?.id);
      toast.success(response);
    } catch (error) {
      console.error("KOT print error:", error);
      toast.error("KOT print unsuccessful.");
    }
  };
  useEffect(() => {
    setSelectedItems([]);
  }, [selectedTable?.id]);
  useEffect(() => {
    setSelectedItems([]);
    setRemarks("");
    setTouched(false);
  }, [selectedTable?.id]);

  useEffect(() => {
    if (!isRight) {
      setPromoCode("");
      setPromoError("");
      setPromoSuccess("");
      setDiscountAmount("");
      setDiscountPercent("");
      // setSelected(null); // Reset local selected state
      setSelectedPayment(null); // Reset parent selectedPayment state
      setLastUpdated(null); // Reset last updated timestamp
      setSelectedPayments([]);
      setPaymentAmounts({});
      setCreditData({});
    }
  }, [isRight]);
  const currentOrder = selectedTable?.id ? orderData[selectedTable.id] : null;
  console.log("🚀 ~ OrderSummary ~ currentOrder:", currentOrder);
  const hasOrderId = currentOrder?.orderId; // Order has been placed
  const isNewItem = currentOrder?.isNewItem; // Flag for new items added

  const getOrderButtonState = () => {
    if (
      !(selectedTable || selectedCourt) ||
      !orderData[selectedTable?.restrotableId || selectedCourt?.TableKey] ||
      !orderData[selectedTable?.restrotableId || selectedCourt?.TableKey].items
    ) {
      return {
        text: "Place Order",
        disabled: true,
        variant: "success",
        action: handlePlaceOrder,
      };
    }

    if (!hasOrderId) {
      return {
        text: "Place Order",
        disabled: false,
        variant: "success",
        action: handlePlaceOrder, // Add this
      };
    }

    if (hasOrderId && (isNewItem || isQuantityChanged)) {
      return {
        text: "Update Order",
        disabled: false,
        variant: "warning",
        action: handlePlaceOrder, // Add this
      };
    }

    return {
      text: "Already Placed",
      disabled: true,
      variant: "secondary",
      action: () => {}, // Optional: empty function for consistency, but not needed since disabled
    };
  };

  const orderButtonState = getOrderButtonState();
  const [expandedItems, setExpandedItems] = useState({});
  const toggleChildren = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };
  const handleCardClick = (itemKey, item) => {
    handleCheckboxChange(itemKey, item);
  };

  const updateQuantity = (productId, newQty) => {
    setItemCounts((prev) => ({
      ...prev,
      [productId]: Math.max(1, Math.min(100, newQty)), // clamp between 1-100
    }));
  };

  return (
    <Card
      className="d-flex flex-column overflow-hidden rounded-4 shadow-sm"
      style={{ height: "97vh" }}
    >
      <Card className="border-0 shadow-sm mb-0 flex-shrink-0">
        <CardBody className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          {/* <div
            className="d-flex align-items-center gap-2 cursor-pointer"
            onClick={toggleTableModal}
          >
            <i
              className="ri-restaurant-line fs-4 text-success"
              title="Select Table"
            ></i>
            <div>
              <div className="text-muted small">Table</div>
              <h6 className="mb-0 fw-bold cursor-pointer">
                {selectedTable?.restrotableTitle || "Select Table"}
              </h6>
            </div>
          </div> */}
          <div
            className="d-flex align-items-center gap-2 cursor-pointer"
            onClick={toggleTableModal}
            disabled={!selectedCourt?.TableKey}
          >
            <i
              className="ri-restaurant-line fs-4 text-success"
              title="Select Food Court"
            ></i>
            <div>
              <div className="text-muted small">Food Court</div>
              <h6 className="mb-0 fw-bold cursor-pointer">
                {selectedCourt?.TableKey || "Select Court"}
              </h6>
            </div>
          </div>
          <button
            onClick={toggleSwitchModal}
            disabled={!selectedTable?.restrotableId}
            className="btn btn-light d-flex flex-column align-items-center justify-content-center border-0 bg-transparent"
            style={{
              cursor: !selectedTable?.restrotableId ? "not-allowed" : "pointer",
            }}
          >
            <div className="text-muted small">Switch</div>
            <i className="bx bx-repost fs-5 text-success cursor-pointer"></i>
          </button>

          {/* <div
            className="d-flex align-items-center gap-2 cursor-pointer"
            onClick={toggleListModal}
          >
            <i
              className="ri-user-line fs-4 text-primary"
              title="Select Customer"
            ></i>
            <div>
              <div className="text-muted small">Customer</div>
              <h6 className="mb-0 fw-bold">
                {selectedCustomer?.firstName || "Select Customer"}
              </h6>
            </div>
          </div> */}
          <div>
            {Object.keys(orderData).length > 0 ? (
              <Button color="light" size="sm" onClick={toggleKOT}>
                <i className="ri-printer-line"></i>
              </Button>
            ) : null}
          </div>
        </CardBody>
      </Card>

      <div
        className="px-lg-4 px-3 py-2 gx-3 gy-4 flex-grow-1 overflow-auto bg-light"
        style={{ minHeight: 0 }}
      >
        {loading ? (
          <Spinner />
        ) : error ? (
          <div className="text-center text-danger">{error}</div>
        ) : selectedTable && !orderData[selectedTable.restrotableId] ? (
          <div className="text-center text-muted">
            No orders found for table {selectedTable.restrotableTitle}.
          </div>
        ) : orderData.length === 0 ? (
          <div className="text-center text-muted">
            No items for the selected table.
          </div>
        ) : (
          <>
            {filteredOrders
              .flatMap((order) => order.items || [])
              .map((item) => {
                console.log("🚀 ~ OrderSummary ~ item:", item);
                const productId = item.productId;
                const count = itemCounts[productId] ?? item.quantity ?? 1;
                const isSelected = selectedItems.some(
                  (i) => i.productId === productId
                );

                return (
                  <div
                    key={productId}
                    className={`rounded-3 shadow-sm px-2 py-2 mb-2 border border-light-subtle transition-all ${
                      isSelected ? "bg-danger-subtle border-danger" : "bg-white"
                    }`}
                    style={{
                      transition: "all 0.3s ease-in-out",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCardClick(productId, item)}
                  >
                    <Row className="align-items-center">
                      <Col xs={3} md={3}>
                        <CardImg
                          src={restro}
                          alt={item.productName}
                          className="img-fluid rounded-3"
                          style={{
                            objectFit: "contain",
                            height: "60px",
                            width: "100%",
                          }}
                        />
                      </Col>
                      <Col xs={8} md={9}>
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="fw-semibold mb-1">
                            {item.productName}
                          </h6>
                          <span className="text-muted small">
                            <strong>Qty:</strong> {count}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between align-items-center text-muted mt-2">
                          {item.quantity > 0 && (
                            <div className="d-flex gap-2 align-items-center">
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="rounded-circle"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateQuantity(productId, count - 1);
                                }}
                              >
                                −
                              </Button>

                              <input
                                type="number"
                                className="form-control form-control-sm text-center w-auto"
                                value={count}
                                min="1"
                                max="100"
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  updateQuantity(
                                    productId,
                                    Number(e.target.value)
                                  )
                                }
                                style={{
                                  width: "40px",
                                  height: "28px",
                                  fontSize: "12px",
                                  padding: 0,
                                }}
                              />

                              <Button
                                variant="outline-secondary"
                                size="sm"
                                className="rounded-circle"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateQuantity(productId, count + 1);
                                }}
                              >
                                +
                              </Button>
                            </div>
                          )}

                          <span className="fs-14 fw-semibold">
                            Rs. {(item.productPrice * count).toFixed(2)}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              })}
          </>
        )}
      </div>

      <div className="bg-white sticky-bottom flex-shrink-0 p-3">
        <div
          style={{ border: "1px dashed #e0e0e0", backgroundColor: "#f8f9fa" }}
          className="p-2 rounded-4 mb-3"
        >
          <div className="d-flex justify-content-between fw-bold fs-6 text-success">
            <span>Total</span>
            <span>Rs. {calculateTotals.total.toFixed(2)}</span>
          </div>
        </div>
        <div className="position-relative w-100">
          {selectedItems.length > 0 ? (
            <div className="transition-slide-left active d-flex gap-2">
              <button
                onClick={toggleDeleteModal}
                className="btn btn-soft-danger  w-50 fw-semibold"
              >
                Cancel Selected Order ({selectedItems.length})
              </button>
              <button
                onClick={toggleSwitchItemModal}
                className="btn btn-soft-success  w-50 fw-semibold"
              >
                Switch item ({selectedItems.length})
              </button>
            </div>
          ) : (
            <div className="transition-slide-left ">
              <Row>
                <Col md={12} lg={12} xl={12} className="mb-2">
                  {isQuantityChanged ? (
                    <button
                      className="btn btn-warning fw-semibold w-100"
                      onClick={handlePlaceOrder}
                      disabled={placedLoading}
                    >
                      Update Order
                    </button>
                  ) : (
                    <button
                      className={`btn btn-${orderButtonState.variant} fw-semibold w-100`}
                      onClick={(e) => {
                        console.log("Button clicked!");
                        orderButtonState.action?.(e);
                      }}
                      disabled={orderButtonState.disabled || placedLoading}
                    >
                      {orderButtonState.text}
                    </button>
                  )}
                </Col>
                {/* <Col md={12} lg={12} xl={6}>
            
                    <button
                      className="btn btn-light fw-semibold w-100"
                      onClick={toggleRightCanvas}
                      disabled={
                        placedLoading
                      }
                    >
                      Process Transaction
                    </button>
            
                </Col> */}
              </Row>
            </div>
          )}
        </div>
      </div>

      {isRight && calculateTotals.subTotal > 0 && (
        <ConfirmPayment
          isOpen={isRight}
          toggle={toggleRightCanvas}
          handleCheckout={handleCheckout}
          billData={orderData}
          selectedPayments={selectedPayments}
          setSelectedPayments={setSelectedPayments}
          selectedPayment={selectedPayment}
          setSelectedPayment={setSelectedPayment}
          handleApplyPromo={handleApplyPromo}
          setPromoCode={setPromoCode}
          promoCode={promoCode}
          calculateTotals={calculateTotals}
          handlePercentChange={handlePercentChange}
          handleAmountChange={handleAmountChange}
          discountPercent={discountPercent}
          setDiscountPercent={setDiscountPercent}
          discountAmount={discountAmount}
          setDiscountAmount={setDiscountAmount}
          promoSuccess={promoSuccess}
          setPromoSuccess={setPromoSuccess}
          promoError={promoError}
          setPromoError={setPromoError}
          selectedTable={selectedTable}
          setLastUpdated={setLastUpdated}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          toggleModal={toggleModal}
          orgInfo={orgInfo}
          user={user}
          selectedCustomer={selectedCustomer}
          toggleListModal={toggleListModal}
          creditData={creditData}
          setCreditData={setCreditData}
          setPaymentAmounts={setPaymentAmounts}
          paymentAmounts={paymentAmounts}
          placedItems={placedItems}
        />
      )}

      <CustomerList
        isOpen={isListOpen}
        toggle={toggleListModal}
        setSelectedCustomer={setSelectedCustomer}
        selectedCustomer={selectedCustomer}
      />

      <FoodCourt
        isOpen={isTableOpen}
        toggle={toggleTableModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        // data={data}
        data={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        setSelectedCourt={setSelectedCourt}
        selectedCourt={selectedCourt}
      />
      <TableSwitch
        isOpen={isSwitchOpen}
        toggle={toggleSwitchModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        mode={"switch-table"}
        orderNo={orderNo}
        fetchOrder={fetchOrder}
        fetchTable={fetchTable}
        orderId={orderId}
        selectedCourt={selectedCourt}
        setSelectedCourt={setSelectedCourt}
      />
      <TableSwitch
        isOpen={isSwitchItemOpen}
        toggle={toggleSwitchItemModal}
        setSelectedTable={setSelectedTable}
        selectedTable={selectedTable}
        data={data}
        sectionData={sectionData}
        setSelectedSection={setSelectedSection}
        selectedSection={selectedSection}
        loading={loading}
        mode={"switch-item"}
        selectedItems={selectedItems}
        fetchOrder={fetchOrder}
        orderData={orderData}
        fetchTable={fetchTable}
        orderId={orderId}
        orderNo={orderNo}
        selectedCourt={selectedCourt}
        setSelectedCourt={setSelectedCourt}
      />
      <PrintBillModal
        isOpen={showPrintModal}
        toggle={() => setShowPrintModal(false)}
        billData={orderData}
      />
      <CancelOrder
        show={deleteModal}
        onDeleteClick={handleDeleteItem}
        onCloseClick={toggleDeleteModal}
        setRemarks={setRemarks}
        remarks={remarks}
        setTouched={setTouched}
        touched={touched}
        isInvalid={isInvalid}
      />
      {/* <PaymentMethod
        isOpen={isPaymentModal}
        toggle={togglePayment}
        setSelectedPayment={setSelectedPayment}
        selectedPayment={selectedPayment}
      /> */}
      {isModalOpen && (
        <InvoiceBillModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          orgInfo={orgInfo}
          user={user}
          selectedTable={selectedTable}
          orderId={orderId}
          billData={billInfo}
          calculateTotals={totalCalculate}
          responseData={responseData}
          selectedCustomer={selectedCustomer}
        />
      )}
      <KOTModal
        isOpen={isKOTOpen}
        toggle={toggleKOT}
        handlePrint={handlePrint}
      />
    </Card>
  );
};

export default OrderSummary;
